export const DA = {
    translations: {
        notifications: 'Meddelelser',
        markAllAsRead: 'Markér alle som læst',
        poweredBy: 'Drevet af',
        settings: 'Indstillinger',
        noNewNotification: 'Intet nyt at se her endnu',
    },
    lang: 'da',
};
//# sourceMappingURL=da.js.map